import { useTranslation } from 'react-i18next';
import RttRoundedIcon from '@mui/icons-material/RttRounded';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { useState } from 'react';

import { COLLAPSED_BUTTON_SIZES, COLLAPSED_BUTTON_TYPES } from '../../../components/collapsed-button/CollapsedButton';
import { addFavoriteMedia } from '../../../redux/ai-studio/aiStudioActions';
import { navigateToStoryWithFavorite, resolveFavoriteId } from '../utils/fromFavoriteToStoryMedia';

const useAdditionalGeneratedCardActions = () => {
  const dispatch = useDispatch();
  const { id: projectId } = useParams();
  const { t } = useTranslation('activ8');

  const [isSavingToFavorite, setIsSavingToFavorite] = useState(false);

  const handleGoToStory = async ({ id, fileName, mediaType, favoriteId }) => {
    let resolvedFavoriteId = resolveFavoriteId(favoriteId);

    if (!resolvedFavoriteId) {
      setIsSavingToFavorite(true);
      const result = await dispatch(addFavoriteMedia({ fileName, mediaType, id, projectId }));

      if (addFavoriteMedia.rejected.match(result)) {
        setIsSavingToFavorite(false);
        return;
      }

      resolvedFavoriteId = resolveFavoriteId(result.payload.favoriteId);
      setIsSavingToFavorite(false);
    }

    if (!resolvedFavoriteId) {
      return;
    }

    navigateToStoryWithFavorite(dispatch, {
      id: resolvedFavoriteId,
      mediaType,
    });
  };

  return [
    {
      label: t('goToStory'),
      icon: RttRoundedIcon,
      type: COLLAPSED_BUTTON_TYPES.TABLE_ROW,
      size: COLLAPSED_BUTTON_SIZES.MEDIUM,
      onClick: handleGoToStory,
      isLoading: isSavingToFavorite,
    },
  ];
};

export default useAdditionalGeneratedCardActions;
